import { render, staticRenderFns } from "./MediumSingle.vue?vue&type=template&id=10b0fc51"
import script from "./MediumSingle.vue?vue&type=script&lang=js"
export * from "./MediumSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports